import { ThemeConfig, theme } from "antd";

export const inevitable: ThemeConfig = {
	token: {
		colorPrimary: '#fae67a',
		colorInfo: '#fae67a',
		colorSuccess: '#6e9c69',
		colorWarning: '#e9c742',
		colorError: '#e44f52',
		// text on solid colored fills (primary buttons, badges, alert headers):
		// antd's default white is unreadable on our light yellows
		colorTextLightSolid: '#020302',
		colorText: '#e3e0cf',
		colorTextBase: '#e3e0cf',
		colorBgBase: '#020302',
		colorBgContainer: 'rgb(0, 0, 0, 0.3)',
	},
	algorithm: theme.darkAlgorithm
};